import React, { FC, Fragment, useEffect, useState } from 'react'
import { TextField, CircularProgress } from '@mui/material'

type OptionValue = string | number
type variant = 'standard' | 'outlined' | 'filled'
type size = 'small' | 'medium'

interface Option<T extends OptionValue> {
  value: T
}

interface AutoCompleteRequiredProps<T extends OptionValue> {
  item: Option<T>[]
  nameList: string
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  labelList: string
  isLoader: boolean
  value?: string | number | boolean
  variant?: variant
  size?: size
  isError?: React.Dispatch<React.SetStateAction<boolean>>
  required?: boolean
}

export const AutoCompleterRequired: FC<
  AutoCompleteRequiredProps<OptionValue>
> = ({
  item,
  nameList,
  handleChange,
  labelList,
  isLoader,
  value,
  variant = 'standard',
  size = 'small',
  isError,
  required = false
}) => {
  const [items, setItems] = useState<any[]>(item)
  const [hasError, setHasError] = useState<boolean>(false)

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (required) {
      const newValue = e.target.value
      // Verifica si el nuevo valor seleccionado está en la lista de items
      const isValidValue = item.some(
        (opt: any) => opt.value === newValue.toLowerCase()
      )

      if (isValidValue) {
        setHasError(false)
        isError && isError(false) // setea el error si se quiere capturar en un formulario padre
      } else {
        // Aquí puedes manejar la validación, como mostrar un mensaje de error o tomar otra acción
        setHasError(true)
        isError && isError(true) // setea el error si se quiere capturar en un formulario padre
      }
    }

    handleChange(e)
  }

  useEffect(() => {
    setItems(item)
  }, [onkeydown])

  return (
    <Fragment>
      <TextField
        error={hasError} // Aplicar el estado de error al TextField
        helperText={hasError ? 'Seleccionar' : undefined}
        autoComplete='off'
        variant={variant}
        name={`${nameList}`}
        size={size}
        label={`${labelList}`}
        onChange={(e: any) => {
          handleValueChange(e)
        }}
        onMouseDown={(e: any) => (e.target.value = '')}
        InputProps={{
          endAdornment: (
            <datalist
              id={`${nameList}`}
              style={{
                position: 'absolute',
                backgroundColor: 'white',
                border: '1px solid blue',
                borderRadius: '0 0 5px 5px',
                borderTop: 'none',
                width: '350px',
                padding: '5px',
                maxHeight: '10rem',
                overflowY: 'auto'
              }}
            >
              {items.length > 0
                ? items.map((opt) => (
                    <option value={opt.value}>{opt.value}</option>
                  ))
                : item.map((opt) => (
                    <option value={opt.value}>{opt.value}</option>
                  ))}
            </datalist>
          ),
          inputProps: {
            list: `${nameList}`
          }
        }}
        value={value}
      />

      {isLoader ? (
        <CircularProgress
          size={20}
          style={{ marginTop: '5px', marginLeft: '5px' }}
        />
      ) : (
        ''
      )}
    </Fragment>
  )
}
